import React, {Component} from 'react';

import Search from "../core/Search";

class Maintenances extends Component {

    constructor(props) {
        super(props);

        this.externalCall = this.externalCall.bind(this);
    }

    externalCall(method) {
        if (method === "addMaintenance") {
            this.props.history.push('/admin/maintenance/');
        }
    }

    render() {
        return (
            <Search
                initData={{DATAGRID_SCREEN_ID: 102}}
                externalCall={this.externalCall} />
        );
    }
}

export default Maintenances;
